"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
/**
 * Create an empty transaction
 *
 * @returns {Transaction}
 */
const createTransaction = () => ({
    family: "stellar",
    amount: new bignumber_js_1.BigNumber(0),
    baseReserve: null,
    networkInfo: null,
    fees: null,
    recipient: "",
    memoValue: null,
    memoType: null,
    useAllAmount: false,
    mode: "send",
    assetCode: "",
    assetIssuer: "",
});
exports.default = createTransaction;
//# sourceMappingURL=js-createTransaction.js.map